
import {
  BrowserRouter as Router,
  Switch
} from "react-router-dom";


//import screens
import LoginScreen from '../src/screens/LoginScreen';
import HomeScreen from '../src/screens/HomeScreen';
import WorkFormScreen from '../src/screens/WorkFormScreen';
import SelfEvalutionScreen from '../src/screens/SelfEvalutionScreen';

import LeaderScreen from "./screens/LeaderScreen";
import LeaderFormScreen from "./screens/LeaderFormScreen";
import WorkLifeFormScreen from "./screens/WorkLifeFormScreen";
// import {checkAuth} from "./guard" TODO after TEST
import ForAdmin from "./screens/ForAdmin";

import SelfFormReport from "./components/SelfFormReport";

import PrivateRoute from './components/PrivateRoute';
import PublicRoute from './components/PublicRoute';
import InfoRoute from './components/InfoRoute';
import ReportRoute from './components/ReportRoute'

import AssessSuborndinateInfo from './screens/AssessSuborndinateInfo'
import AssessingSubordinateScreen from './screens/AssessingSubordinateScreen'


import React from "react";
import SubordinateReport from "./components/SubordinateReport";
import PointsofWorkReportComponent from "./components/PointsofWorkReport";
import VaccineHome from "./screens/VaccineHome";
import CovidInfoAdd from "./screens/CovidInfoAdd"
import CovidInfoUpdate from "./screens/CovidInfoUpdate";


export default class App extends React.Component {

  constructor() {
    super();
    this.state = {
      language: localStorage.getItem("Language"),
    };
  }

  changeLangFunction(item) {
    console.log('222222')
    localStorage.setItem("Language", item);
    this.setState({ language: item });
  }
  

  render(){
    return (

      <Router>

        <Switch>
          <PublicRoute component={LoginScreen} exact path="/" />
          <PrivateRoute component={HomeScreen} path="/home" />
          <PrivateRoute component={WorkFormScreen} path="/workform" />
          <PrivateRoute component={SelfEvalutionScreen} path="/self-evalution" />
          <PrivateRoute component={SelfFormReport} path="/self-evalution-report" />
          <InfoRoute component={LeaderScreen} path="/leader" />
          <InfoRoute component={LeaderFormScreen} path="/leader-form/ID:id" />
          <PrivateRoute component={ForAdmin} path="/for-admin" />
          <PrivateRoute component={WorkLifeFormScreen} path="/worklife-form" />
          <PrivateRoute component={AssessingSubordinateScreen} path="/assessing-subordinate" />
          <InfoRoute component={AssessSuborndinateInfo} path="/assess-info/ID:id" />
          <InfoRoute component={SubordinateReport} path="/assess-report/ID:id" />
          <InfoRoute component={PointsofWorkReportComponent} path="/pointsofwork-report" />
          <PrivateRoute component={VaccineHome} path="/vaccine-info" />
          <InfoRoute component={CovidInfoAdd} path="/covid-add" />
          <InfoRoute component={CovidInfoUpdate} path="/covid-update" />

        </Switch>
    </Router>
  



  
  );
}

}
